<template>
  <TooltipEffect v-bind="$attrs" :color="color" :message="message" :text="text">
    <template #activator="{on}">
      <v-icon :size="size" :color="color" v-on="on">{{ icon }}</v-icon>
    </template>
  </TooltipEffect>
</template>
<script>
export default {
  name: 'TooltipWithIcon',
  inheritAttrs: false,
  props: {
    message: {
      type: [String, Number],
      default: '',
    },
    color: {
      type: String,
      default: 'blue',
    },
    icon: {
      type: String,
      default: 'mdi-information-outline',
    },
    size: {
      type: [String, Number],
      default: 18,
    },
    text: {
      type: String,
      default: 'lowercase',
    },
  },
}
</script>
